<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="h-auto overflow-auto flex flex-col mb-30 pb-10">
      <woot-modal-header
        :header-title="$t('BULK_ACTION.COMPLAINT.COMPLAINT_HEADER')"
      />
      <div class="mt-4 px-8">
        <div class="gap-2 flex flex-row">
          <div class="w-[50%]">
            <label>
              <input
                class="checkbox pr-1"
                type="checkbox"
                v-model="prioritySelected"
              />
              {{ $t('COMPLAINT.PRIORITY_TYPE') }}
            </label>
          </div>
          <div class="w-[50%]">
            <label>
              <input
                class="checkbox pr-1"
                type="checkbox"
                v-model="massSelected"
              />
              {{ $t('COMPLAINT.MASS_TYPE') }}
            </label>
          </div>
        </div>
        <div v-if="massSelected">
          <div class="w-full py-2">
            <label for="massComplaintInput" class="mb-2">
              {{ $t('COMPLAINT.MASS_COMPLAINT') }}</label
            >
            <input
              type="text"
              class="text mb-0"
              v-model="massComplaint"
              list="massComplaintOptionsList"
              id="massComplaintInput"
              :placeholder="$t('COMPLAINT.INPUT_PLACEHOLDER.MASS_INPUT')"
            />
            <datalist id="massComplaintOptionsList">
              <option
                v-for="option in massComplaintOptions"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </datalist>
          </div>
        </div>
        <div class="gap-2 flex flex-row">
          <div class="w-full" v-if="listConversations.length > 0">
            <label class="mb-2"> {{ $t('COMPLAINT.CONTACT_NAME') }}</label>
            <input
              class="text"
              type="text"
              disabled
              :value="displayContactName"
            />
          </div>
          <div class="w-full" v-else>
            <!-- <div class="flex flex-col items-center">
              <label class="self-start">Input Nama Pelanggan</label>
              <input
                type="file"
                @change="onCustomerNameChanged"
                accept=".xlsx"
                class="my-3"
              />
            </div> -->
            <div class="flex flex-col items-center">
              <label class="self-start">
                {{ $t('COMPLAINT.CHOOSE_CUSTOMER') }}</label
              >
              <div
                v-if="paketBerjalanId.length > 0"
                class="flex flex-row items-center self-start"
              >
                <p class="text-white my-4">
                  {{ paketBerjalanId.length }}
                  {{ $t('COMPLAINT.CHOOSEN_CUSTOMER') }}
                </p>
                <woot-button
                  class="my-2 ml-4"
                  color-scheme="alert"
                  icon="delete"
                  size="tiny"
                  @click="resetSelection"
                >
                </woot-button>
              </div>
              <woot-button
                v-else
                class="clear self-start my-2"
                color-scheme="primary"
                icon="eye-show"
                @click="toggleCustomerList"
              >
                {{ $t('COMPLAINT.SHOW_LIST') }}
              </woot-button>
              <CustomerListModal
                :show="showCustomerList"
                @close="closeCustomerList"
                @selected-pelanggans="listPelanggans"
              />
            </div>

            <div v-if="customer_name_file == null">
              <label class="mb-1 mt-2"> {{ $t('COMPLAINT.CUSTOMER') }}</label>
              <multiselect
                v-model="pelangganSelected"
                :max-height="160"
                :options="pelanggans"
                track-by="id_order"
                label="nama_pelanggan"
                :multiple="true"
                :close-on-select="true"
                :clear-on-select="true"
                @search-change="onSelectSearch"
                :hide-selected="true"
                :placeholder="$t('COMPLAINT.CHOOSE_CUSTOMER')"
                :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
                :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
                class="custom-multiselect"
              />
            </div>
          </div>
        </div>
        <div class="gap-2 flex flex-row">
          <div class="w-[50%]">
            <label class="mb-2"> {{ $t('COMPLAINT.CHOOSE_ISSUE') }}</label>
            <select :max-height="160" v-model="issueSelected">
              <option disabled value="">
                {{ $t('COMPLAINT.CHOOSE_LABEL') }}
              </option>
              <option
                v-for="issue in issues"
                :key="issue.value"
                :value="issue.value"
              >
                {{ issue.label }}
              </option>
            </select>
          </div>
          <div class="w-[50%]">
            <label class="mb-2"> {{ $t('COMPLAINT.COMPLAINT_FROM') }}</label>
            <select :max-height="160" v-model="sourceSelected">
              <option disabled value="">
                {{ $t('COMPLAINT.CHOOSE_LABEL') }}
              </option>
              <option
                v-for="source in sources"
                :key="source.value"
                :value="source.value"
              >
                {{ source.label }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="issueSelected === 8">
          <label class="my-2">
            {{ $t('COMPLAINT.OTHER_ISSUE_DESCRIPTION') }}</label
          >
          <div class="w-full">
            <input
              class="text"
              type="text"
              v-model="otherIssue"
              :placeholder="$t('COMPLAINT.INPUT_PLACEHOLDER.OTHER_ISSUE_INPUT')"
            />
          </div>
        </div>
        <div v-if="issueSelected === 2">
          <label class="my-2"> {{ $t('COMPLAINT.OFF_PERIOD') }}</label>
          <Datepicker
            v-model="customDateRange"
            range
            type="datetime"
            format="YYYY-MM-DD HH:mm"
            :confirm="true"
            :not-auto-close="false"
            confirm-text="Pilih"
            class="w-full"
            @change="onChangeRange"
          />
        </div>
        <div class="gap-2 flex flex-row">
          <div class="w-[50%]">
            <label class="mb-2"> {{ $t('COMPLAINT.COMPLAINT_DATE') }} </label>
            <input type="date" v-model="currentDate" class="mb-0 datepicker" />
          </div>
          <div class="w-[50%]">
            <label class="mb-2"> {{ $t('COMPLAINT.COMPLAINT_TIME') }} </label>
            <input type="time" v-model="currentTime" class="mb-0 timepicker" />
          </div>
        </div>
        <div class="mt-4">
          <label class="mb-2"> {{ $t('COMPLAINT.DESCRIPTION') }}</label>
          <textarea
            v-model="message"
            class="min-h-[5rem]"
            type="text"
            :placeholder="$t('COMPLAINT.INPUT_PLACEHOLDER.DESCRIPTION_INPUT')"
          />
        </div>
        <div class="flex flex-col items-center">
          <label class="self-start"> {{ $t('COMPLAINT.ADD_PICTURE') }}</label>
          <input
            type="file"
            @change="onFileChange"
            multiple
            accept="image/*"
            class="my-3"
          />
        </div>
        <div class="flex flex-row justify-end gap-2 pt-5 px-0 w-full">
          <woot-button type="submit" @click="saveComplaint">
            <template v-if="isLoading">
              <spinner />
            </template>
            <template v-else> {{ $t('COMPLAINT.SAVE_BUTTON') }} </template>
          </woot-button>
          <button class="button clear" @click.prevent="onCancel">
            {{ $t('COMPLAINT.CANCEL_BUTTON') }}
          </button>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import Spinner from 'shared/components/Spinner.vue';
import { mapGetters } from 'vuex';
import axios from 'axios';
import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
import WootDateRangePicker from 'dashboard/components/ui/DateRangePicker.vue';
import alertMixin from '../../../../../shared/mixins/alertMixin';
import Datepicker from 'vue2-datepicker';
import CustomerListModal from './CustomerListModal.vue';

export default {
  mixins: [alertMixin],
  data() {
    return {
      isLoading: false,
      massSelected: false,
      prioritySelected: false,
      showCustomerList: false,
      pelangganList: [],
      message: '',
      massComplaint: '',
      sourceSelected: 3,
      issueSelected: 1,
      otherIssue: '',
      currentDate: '',
      currentTime: '',
      contactId: '',
      contactData: '',
      pelangganSelected: [],
      contactDetail: '',
      customDateRange: [],
      massComplaintOptions: [],
      uploadedImages: [],
      sources: [],
      issues: [],
      listConversations: [],
      orderQuery: {
        filter: 'all',
      },
      customer_name_file: null,
      paketBerjalanId: [],
    };
  },
  components: {
    Spinner,
    CustomerListModal,
    WootDateTimePicker,
    WootDateRangePicker,
    Datepicker,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    conversationCount: {
      type: Number,
      default: 0,
    },
    conversation: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters({
      currentUserID: 'getCurrentUserID',
      records: 'contacts/getContacts',
      orderMeta: 'orders/getOrdersMeta',
      orders: 'orders/getOrders',
    }),
    pelanggans() {
      return Object.values(this.orders);
    },
    displayContactName() {
      if (this.conversation.length === 1) {
        if (this.listConversations.length > 0) {
          return this.listConversations[0].contact.name;
        }

        return 'Waiting...';
      } else if (this.conversation.length > 1) {
        if (this.listConversations.length > 0) {
          return `${this.listConversations[0].contact.name}, +${
            this.conversation.length - 1
          } lainnya`;
        }

        return 'Waiting...';
      } else {
        return '';
      }
    },

    isMassComplaint() {
      return this.massSelected != false;
    },
  },

  methods: {
    toggleCustomerList() {
      this.showCustomerList = true;
    },
    closeCustomerList() {
      this.showCustomerList = !this.showCustomerList;
    },
    onCustomerNameChanged(event) {
      this.customer_name_file = event.target.files[0];
    },
    onSelectSearch(query) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        this.$store.dispatch('orders/get', {
          filter: 'all',
          search: query,
        });
      }, 500);
    },
    resetForm() {
      let form = {
        massSelected: false,
        prioritySelected: false,
        message: '',
        massComplaint: '',
        sourceSelected: 3,
        issueSelected: 1,
        otherIssue: '',
        currentDate: '',
        currentTime: '',
        contactId: '',
        contactData: '',
        pelangganSelected: [],
        contactDetail: '',
        customDateRange: [],
        massComplaintOptions: [],
        uploadedImages: [],
        listConversations: [],
        customer_name_file: null,
        paketBerjalanId: [],
      };

      Object.keys(form).forEach(element => {
        this[element] = form[element];
      });

      this.setDefaultDateAndTime();
    },
    onChangeRange(value) {
      this.customDateRange = value;
    },
    listPelanggans(paketBerjalanId) {
      this.showCustomerList = false;
      this.paketBerjalanId = paketBerjalanId;
    },
    onCancel() {
      this.$emit('cancel');
    },
    resetSelection() {
      this.paketBerjalanId = [];
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.uploadedImage = file;
    },
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = error => {
          reject(error);
        };
      });
    },
    async fetchDetail() {
      try {
        const contactId = this.contactId;
        const currentRecord = this.records.find(
          record => record.id === contactId
        );

        if (currentRecord) {
          this.contactDetail = currentRecord;
        }
      } catch (error) {
        console.error('Error fetching record detail:', error);
      }
    },
    async fetchRecord(contactId) {
      try {
        const currentRecord = this.records.find(
          record => record.id === contactId
        );

        if (currentRecord) {
          this.contactData = currentRecord;
        }
      } catch (error) {
        console.error('Error fetching record data:', error);
      }
    },
    async fetchConversations() {
      try {
        const response = await axios.get('/complaint_conversations', {
          params: { ids: this.conversation },
        });
        this.listConversations = response.data;
        const bulkListConversation = this.listConversations.filter(conv =>
          this.conversation.includes(conv.display_id)
        );

        this.contactIds = bulkListConversation.map(conv => conv.contact_id);
        if (this.contactIds.length > 0) {
          this.contactId = this.contactIds[0];
          this.fetchDetail();
        }
      } catch (error) {
        console.error('Error fetching conversation data:', error);
      }
    },
    async fetchIssues() {
      try {
        const response = await axios.get('/problems');
        this.issues = response.data.map(problem => ({
          value: problem.id,
          label: this.$t(`COMPLAINT.ISSUES.${problem.id}`),
        }));
      } catch (error) {
        console.error('Error fetching issues:', error);
      }
    },
    async fetchSources() {
      try {
        const response = await axios.get('/complaint_sources');
        this.sources = response.data.map(source => ({
          value: source.id,
          label: this.$t(`COMPLAINT.SOURCE.${source.id}`),
        }));
      } catch (error) {
        console.error('Error fetching sources data:', error);
      }
    },
    async saveComplaint() {
      this.isLoading = true;
      try {
        let utcStartDate = null;
        let utcEndDate = null;

        if (
          this.customDateRange &&
          this.customDateRange[0] &&
          this.customDateRange[1]
        ) {
          const startDate = new Date(this.customDateRange[0]);
          const endDate = new Date(this.customDateRange[1]);
          utcStartDate = startDate.toISOString();
          utcEndDate = endDate.toISOString();
        }

        const formData = new FormData();
        formData.append('complaint_date', this.currentDate);
        formData.append('complaint_source_id', this.sourceSelected);
        formData.append('complaint_time', this.currentTime);
        formData.append('description', this.message);
        formData.append('is_mass_complaint', this.isMassComplaint ? 1 : 0);
        formData.append(
          'mass_complaint_description',
          this.isMassComplaint ? this.massComplaint : null
        );
        formData.append('priority', this.prioritySelected ? 1 : 0);
        formData.append('problem_id', this.issueSelected);
        formData.append('status_id', 2);
        formData.append('offline_range_start_date', utcStartDate);
        formData.append('offline_range_end_date', utcEndDate);
        formData.append('work_order_id', null);
        if (this.uploadedImage) {
          formData.append('images', this.uploadedImage);
        }
        formData.append('conversation_ids', this.conversation);
        formData.append('other_issue', this.otherIssue);
        formData.append('pelanggans', JSON.stringify(this.pelangganSelected));
        formData.append('customer_name_file', this.customer_name_file);
        formData.append('paket_berjalan_id', this.paketBerjalanId);

        const {
          data: { data },
        } = await this.$store.dispatch('complaints/create', formData);

        this.$emit('complaint-created');

        this.resetForm();

        let action = null;
        if (data.length == 1) {
          action = {
            type: 'link',
            to: `/app/accounts/${data[0].account_id}/complaints/${data[0].id}/edit`,
            message: this.$t('NEW_CONVERSATION.FORM.GO_TO_CONVERSATION'),
          };
        }

        this.showAlert(this.$t('COMPLAINT.SUCCESS_CREATE_COMPLAINT'), action);
        this.$emit('cancel');
      } catch (error) {
        console.error('Error saving complaint:', error);
        this.showAlert(this.$t('COMPLAINT.FAIL_CREATE_COMPLAINT'), action);
      } finally {
        this.isLoading = false;
      }
    },

    setDefaultDateAndTime() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      this.currentDate = `${year}-${month}-${day}`;
      const hours = String(today.getHours()).padStart(2, '0');
      const minutes = String(today.getMinutes()).padStart(2, '0');
      this.currentTime = `${hours}:${minutes}`;
    },
  },

  mounted() {
    this.fetchConversations();
    this.fetchIssues();
    this.fetchSources();
    this.setDefaultDateAndTime();
    if (this.listConversations.length == 0) {
      this.$store.dispatch('orders/get', this.orderQuery);
    }
  },
};
</script>
